import {
  FETCH_PATHWAYS_REQUEST,
  FETCH_PATHWAY_REQUEST,
  FETCH_PROJECTS_REQUEST,
  RECEIVE_PATHWAY,
  RECEIVE_PATHWAYS,
  RECEIVE_PATHWAYS_ERROR,
  RECEIVE_PATHWAY_ERROR,
  RECEIVE_PROJECTS,
  RECEIVE_PROJECTS_ERROR,
} from 'redux/constants/ActionTypes'

import { createApiAction } from './ApiActions'

// API actions
export const fetchPathways = (currentLocale, isBeta = false) => {
  return createApiAction({
    endpoint: `/${currentLocale}/pathways/?is_beta=${isBeta ? 1 : 0}`,
    types: [FETCH_PATHWAYS_REQUEST, RECEIVE_PATHWAYS, RECEIVE_PATHWAYS_ERROR],
    currentLocale,
    isBeta,
  })
}

export const fetchPathway = (currentLocale, slug) => {
  return createApiAction({
    endpoint: `/${currentLocale}/pathways/${slug}`,
    types: [FETCH_PATHWAY_REQUEST, RECEIVE_PATHWAY, RECEIVE_PATHWAY_ERROR],
    currentLocale,
    slug,
  })
}

export const fetchPathwayProjects = (
  currentLocale,
  slug,
  authToken,
  session
) => {
  return createApiAction({
    types: [FETCH_PROJECTS_REQUEST, RECEIVE_PROJECTS, RECEIVE_PROJECTS_ERROR],
    endpoint: `/${currentLocale}/pathways/${slug}/projects?session_progress=${session}`,
    currentLocale,
    authToken,
    slug,
  })
}
